import { render, staticRenderFns } from "./CorrespondenceVoteAndSign.vue?vue&type=template&id=7c85a808&"
import script from "./CorrespondenceVoteAndSign.vue?vue&type=script&lang=js&"
export * from "./CorrespondenceVoteAndSign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports